export { default } from "./TextValue";
